import * as i0 from "@angular/core";
var UtilityCookieService = /** @class */ (function () {
    function UtilityCookieService() {
    }
    /**
     * "https://github.com/BCJTI/ng2-cookies"
     * Checks the existence of a single cookie by it's name
     *
     * param name Identification of the cookie
     * returns existence of the cookie
     */
    UtilityCookieService.checkCookieExists = function (name) {
        name = encodeURIComponent(name);
        var regexp = new RegExp('(?:^' + name + '|;\\s*' + name + ')=(.*?)(?:;|$)', 'g');
        var exists = regexp.test(document.cookie);
        return exists;
    };
    /**
     * Retrieves a single cookie by it's name
     *
     * param name Identification of the Cookie
     * returns The Cookie's value
     */
    UtilityCookieService.getCookie = function (name) {
        if (UtilityCookieService.checkCookieExists(name)) {
            name = encodeURIComponent(name);
            var regexp = new RegExp('(?:^' + name + '|;\\s*' + name + ')=(.*?)(?:;|$)', 'g');
            var result = regexp.exec(document.cookie);
            return decodeURIComponent(result[1]);
        }
        else {
            return '';
        }
    };
    /**
     * Save the cookie
     *
     * param cookie Cookie name, value
     */
    UtilityCookieService.setCookie = function (cookie) {
        // name: string, value: string, expires?: number | Date, path?: string, domain?: string, secure?: boolean) {
        var cookieStr = encodeURIComponent(cookie.name) + '=' + encodeURIComponent(cookie.value) + ';';
        if (cookie.expires) {
            if (typeof cookie.expires === 'number') {
                var dtExpires = new Date(new Date().getTime() + cookie.expires * 1000 * 60 * 60 * 24);
                cookieStr += 'expires=' + dtExpires.toUTCString() + ';';
            }
            else {
                cookieStr += 'expires=' + cookie.expires['toUTCString']() + ';';
            }
        }
        if (cookie.path) {
            cookieStr += 'path=' + cookie.path + ';';
        }
        if (cookie.domain) {
            cookieStr += 'domain=' + cookie.domain + ';';
        }
        if (cookie.secure) {
            cookieStr += 'secure;';
        }
        // console.log(cookieStr);
        document.cookie = cookieStr;
    };
    /**
     * Removes specified Cookie
     *
     * param name Cookie's identification name
     */
    UtilityCookieService.deleteCookie = function (cookie) {
        // If the cookie exists
        if (UtilityCookieService.getCookie(cookie.name)) {
            UtilityCookieService.setCookie(cookie);
        }
    };
    /**
     * Assert cookie value
     */
    UtilityCookieService.assertCookieValue = function (cookieName, value) {
        var ck = UtilityCookieService.getCookie(cookieName) || '';
        return ck.toLowerCase() === (value || '').toLowerCase();
    };
    UtilityCookieService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UtilityCookieService_Factory() { return new UtilityCookieService(); }, token: UtilityCookieService, providedIn: "root" });
    return UtilityCookieService;
}());
export { UtilityCookieService };
